/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as AutomationsRouteImport } from './routes/automations'
import { Route as ComplianceRouteImport } from './routes/compliance'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as ConnectionsRouteImport } from './routes/connections'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as PairRouteImport } from './routes/pair'
import { Route as RegulationRouteImport } from './routes/regulation'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as OrgAgentsRouteImport } from './routes/$org.agents'
import { Route as OrgAutomationsRouteImport } from './routes/$org.automations'
import { Route as OrgCommandCenterRouteImport } from './routes/$org.command-center'
import { Route as OrgComplianceRouteImport } from './routes/$org.compliance'
import { Route as OrgConnectionsRouteImport } from './routes/$org.connections'
import { Route as OrgInboxRouteImport } from './routes/$org.inbox'
import { Route as OrgSettingsRouteImport } from './routes/$org.settings'
import { Route as OrgUsageRouteImport } from './routes/$org.usage'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as ConnectCallbackRouteImport } from './routes/connect_.callback'
import { Route as ConnectionsPluginIdRouteImport } from './routes/connections_.$pluginId'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsBrandingRouteImport } from './routes/settings.branding'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsMembersRouteImport } from './routes/settings.members'
import { Route as SettingsOrganizationRouteImport } from './routes/settings.organization'
import { Route as SettingsSecurityRouteImport } from './routes/settings.security'
import { Route as SettingsUsageRouteImport } from './routes/settings.usage'
import { Route as SettingsYourContextRouteImport } from './routes/settings.your-context'
import { Route as OrgAppsIndexRouteImport } from './routes/$org.apps.index'
import { Route as OrgAppsAppIdRouteImport } from './routes/$org.apps.$appId'
import { Route as OrgAppsContractIntelligenceRouteImport } from './routes/$org.apps.contract-intelligence'
import { Route as OrgAppsImanageRouteImport } from './routes/$org.apps.imanage'
import { Route as OrgAppsProbeRouteImport } from './routes/$org.apps.probe'
import { Route as OrgComplianceIndexRouteImport } from './routes/$org.compliance.index'
import { Route as OrgComplianceFrameworksRouteImport } from './routes/$org.compliance.frameworks'
import { Route as OrgComplianceInspectorRouteImport } from './routes/$org.compliance.inspector'
import { Route as OrgComplianceIntegrationsRouteImport } from './routes/$org.compliance.integrations'
import { Route as OrgComplianceKnowledgeRouteImport } from './routes/$org.compliance.knowledge'
import { Route as OrgCompliancePoliciesRouteImport } from './routes/$org.compliance.policies'
import { Route as OrgComplianceProbeRouteImport } from './routes/$org.compliance.probe'
import { Route as OrgComplianceProceduresRouteImport } from './routes/$org.compliance.procedures'
import { Route as OrgComplianceRegimesRouteImport } from './routes/$org.compliance.regimes'
import { Route as OrgComplianceRegulatoryRouteImport } from './routes/$org.compliance.regulatory'
import { Route as OrgComplianceSuggestionsRouteImport } from './routes/$org.compliance.suggestions'
import { Route as OrgComplianceTemplatesRouteImport } from './routes/$org.compliance.templates'
import { Route as OrgConnectionsPluginIdRouteImport } from './routes/$org.connections_.$pluginId'
import { Route as OrgRegulationIndexRouteImport } from './routes/$org.regulation.index'
import { Route as OrgRegulationSplatRouteImport } from './routes/$org.regulation.$'
import { Route as OrgSettingsSectionRouteImport } from './routes/$org.settings.$section'
import { Route as OrgSkillsIndexRouteImport } from './routes/$org.skills.index'
import { Route as OrgSkillsSlugRouteImport } from './routes/$org.skills.$slug'
import { Route as OrgSpacesIndexRouteImport } from './routes/$org.spaces.index'
import { Route as OrgSpacesSpaceIdRouteImport } from './routes/$org.spaces.$spaceId'
import { Route as OrgWorkflowsIndexRouteImport } from './routes/$org.workflows.index'
import { Route as OrgWorkflowsWorkflowIdRouteImport } from './routes/$org.workflows.$workflowId'
import { Route as ChatOrgIndexRouteImport } from './routes/_chat.$org.index'
import { Route as ChatOrgThreadIdRouteImport } from './routes/_chat.$org.$threadId'
import { Route as ChatOrgChatRouteImport } from './routes/_chat.$org.chat'
import { Route as OrgAppsContractIntelligenceIndexRouteImport } from './routes/$org.apps.contract-intelligence.index'
import { Route as OrgAppsContractIntelligenceDocumentsRouteImport } from './routes/$org.apps.contract-intelligence.documents'
import { Route as OrgAppsContractIntelligenceNewRouteImport } from './routes/$org.apps.contract-intelligence.new'
import { Route as OrgAppsContractIntelligenceSettingsRouteImport } from './routes/$org.apps.contract-intelligence.settings'
import { Route as OrgAppsContractIntelligenceTemplatesRouteImport } from './routes/$org.apps.contract-intelligence.templates'
import { Route as OrgAppsCustomServerIdRouteImport } from './routes/$org.apps.custom.$serverId'
import { Route as OrgAppsImanageIndexRouteImport } from './routes/$org.apps.imanage.index'
import { Route as OrgAppsImanageAboutRouteImport } from './routes/$org.apps.imanage.about'
import { Route as OrgAppsImanageFavoritesRouteImport } from './routes/$org.apps.imanage.favorites'
import { Route as OrgAppsImanageRecentRouteImport } from './routes/$org.apps.imanage.recent'
import { Route as OrgAppsImanageSavedRouteImport } from './routes/$org.apps.imanage.saved'
import { Route as OrgAppsImanageSearchRouteImport } from './routes/$org.apps.imanage.search'
import { Route as OrgAppsImanageSettingsRouteImport } from './routes/$org.apps.imanage.settings'
import { Route as OrgAppsProbeIndexRouteImport } from './routes/$org.apps.probe.index'
import { Route as OrgAppsProbeBriefingRouteImport } from './routes/$org.apps.probe.briefing'
import { Route as OrgAppsProbePracticeRouteImport } from './routes/$org.apps.probe.practice'
import { Route as OrgComplianceFindingsIndexRouteImport } from './routes/$org.compliance.findings.index'
import { Route as OrgComplianceFindingsFindingIdRouteImport } from './routes/$org.compliance.findings.$findingId'
import { Route as OrgComplianceFrameworksIndexRouteImport } from './routes/$org.compliance.frameworks.index'
import { Route as OrgComplianceFrameworksFrameworkIdRouteImport } from './routes/$org.compliance.frameworks.$frameworkId'
import { Route as OrgComplianceInspectorThreadIdRouteImport } from './routes/$org.compliance.inspector_.$threadId'
import { Route as OrgComplianceIntegrationsIntegrationIdRouteImport } from './routes/$org.compliance.integrations_.$integrationId'
import { Route as OrgCompliancePoliciesIndexRouteImport } from './routes/$org.compliance.policies.index'
import { Route as OrgCompliancePoliciesPolicyIdRouteImport } from './routes/$org.compliance.policies.$policyId'
import { Route as OrgComplianceRegimesRegimeIdRouteImport } from './routes/$org.compliance.regimes_.$regimeId'
import { Route as OrgComplianceSuggestionsRecommendationIdRouteImport } from './routes/$org.compliance.suggestions_.$recommendationId'
import { Route as OrgConnectionsMcpServerIdRouteImport } from './routes/$org.connections_.mcp.$serverId'
import { Route as ChatOrgDraftDraftIdRouteImport } from './routes/_chat.$org.draft.$draftId'
import { Route as OrgAppsContractIntelligenceReviewsIndexRouteImport } from './routes/$org.apps.contract-intelligence.reviews.index'
import { Route as OrgAppsContractIntelligenceReviewsReviewIdRouteImport } from './routes/$org.apps.contract-intelligence.reviews.$reviewId'
import { Route as OrgAppsImanageWWorkspaceIdRouteImport } from './routes/$org.apps.imanage.w.$workspaceId'
import { Route as OrgAppsProbeInterviewsIndexRouteImport } from './routes/$org.apps.probe.interviews.index'
import { Route as OrgAppsProbeInterviewsSessionIdRouteImport } from './routes/$org.apps.probe.interviews.$sessionId'
import { Route as OrgComplianceIntegrationsCustomServerIdRouteImport } from './routes/$org.compliance.integrations_.custom.$serverId'
import { Route as OrgAppsImanageWWorkspaceIdFolderIdRouteImport } from './routes/$org.apps.imanage.w.$workspaceId_.$folderId'
import { Route as OrgCompliancePoliciesPolicyIdVersionsVersionRouteImport } from './routes/$org.compliance.policies.$policyId_.versions.$version'

const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationsRoute = AutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectionsRoute = ConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const RegulationRoute = RegulationRouteImport.update({
  id: '/regulation',
  path: '/regulation',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAgentsRoute = OrgAgentsRouteImport.update({
  id: '/$org/agents',
  path: '/$org/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAutomationsRoute = OrgAutomationsRouteImport.update({
  id: '/$org/automations',
  path: '/$org/automations',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgCommandCenterRoute = OrgCommandCenterRouteImport.update({
  id: '/$org/command-center',
  path: '/$org/command-center',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgComplianceRoute = OrgComplianceRouteImport.update({
  id: '/$org/compliance',
  path: '/$org/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgConnectionsRoute = OrgConnectionsRouteImport.update({
  id: '/$org/connections',
  path: '/$org/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgInboxRoute = OrgInboxRouteImport.update({
  id: '/$org/inbox',
  path: '/$org/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSettingsRoute = OrgSettingsRouteImport.update({
  id: '/$org/settings',
  path: '/$org/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgUsageRoute = OrgUsageRouteImport.update({
  id: '/$org/usage',
  path: '/$org/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect_/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectionsPluginIdRoute = ConnectionsPluginIdRouteImport.update({
  id: '/connections_/$pluginId',
  path: '/connections/$pluginId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBrandingRoute = SettingsBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUsageRoute = SettingsUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsYourContextRoute = SettingsYourContextRouteImport.update({
  id: '/your-context',
  path: '/your-context',
  getParentRoute: () => SettingsRoute,
} as any)
const OrgAppsIndexRoute = OrgAppsIndexRouteImport.update({
  id: '/$org/apps/',
  path: '/$org/apps/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAppsAppIdRoute = OrgAppsAppIdRouteImport.update({
  id: '/$org/apps/$appId',
  path: '/$org/apps/$appId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAppsContractIntelligenceRoute =
  OrgAppsContractIntelligenceRouteImport.update({
    id: '/$org/apps/contract-intelligence',
    path: '/$org/apps/contract-intelligence',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrgAppsImanageRoute = OrgAppsImanageRouteImport.update({
  id: '/$org/apps/imanage',
  path: '/$org/apps/imanage',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAppsProbeRoute = OrgAppsProbeRouteImport.update({
  id: '/$org/apps/probe',
  path: '/$org/apps/probe',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgComplianceIndexRoute = OrgComplianceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceFrameworksRoute = OrgComplianceFrameworksRouteImport.update({
  id: '/frameworks',
  path: '/frameworks',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceInspectorRoute = OrgComplianceInspectorRouteImport.update({
  id: '/inspector',
  path: '/inspector',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceIntegrationsRoute =
  OrgComplianceIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgComplianceKnowledgeRoute = OrgComplianceKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgCompliancePoliciesRoute = OrgCompliancePoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceProbeRoute = OrgComplianceProbeRouteImport.update({
  id: '/probe',
  path: '/probe',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceProceduresRoute = OrgComplianceProceduresRouteImport.update({
  id: '/procedures',
  path: '/procedures',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceRegimesRoute = OrgComplianceRegimesRouteImport.update({
  id: '/regimes',
  path: '/regimes',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceRegulatoryRoute = OrgComplianceRegulatoryRouteImport.update({
  id: '/regulatory',
  path: '/regulatory',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgComplianceSuggestionsRoute =
  OrgComplianceSuggestionsRouteImport.update({
    id: '/suggestions',
    path: '/suggestions',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgComplianceTemplatesRoute = OrgComplianceTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => OrgComplianceRoute,
} as any)
const OrgConnectionsPluginIdRoute = OrgConnectionsPluginIdRouteImport.update({
  id: '/$org/connections_/$pluginId',
  path: '/$org/connections/$pluginId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRegulationIndexRoute = OrgRegulationIndexRouteImport.update({
  id: '/$org/regulation/',
  path: '/$org/regulation/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRegulationSplatRoute = OrgRegulationSplatRouteImport.update({
  id: '/$org/regulation/$',
  path: '/$org/regulation/$',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSettingsSectionRoute = OrgSettingsSectionRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSkillsIndexRoute = OrgSkillsIndexRouteImport.update({
  id: '/$org/skills/',
  path: '/$org/skills/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSkillsSlugRoute = OrgSkillsSlugRouteImport.update({
  id: '/$org/skills/$slug',
  path: '/$org/skills/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSpacesIndexRoute = OrgSpacesIndexRouteImport.update({
  id: '/$org/spaces/',
  path: '/$org/spaces/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSpacesSpaceIdRoute = OrgSpacesSpaceIdRouteImport.update({
  id: '/$org/spaces/$spaceId',
  path: '/$org/spaces/$spaceId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgWorkflowsIndexRoute = OrgWorkflowsIndexRouteImport.update({
  id: '/$org/workflows/',
  path: '/$org/workflows/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgWorkflowsWorkflowIdRoute = OrgWorkflowsWorkflowIdRouteImport.update({
  id: '/$org/workflows/$workflowId',
  path: '/$org/workflows/$workflowId',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatOrgIndexRoute = ChatOrgIndexRouteImport.update({
  id: '/$org/',
  path: '/$org/',
  getParentRoute: () => ChatRoute,
} as any)
const ChatOrgThreadIdRoute = ChatOrgThreadIdRouteImport.update({
  id: '/$org/$threadId',
  path: '/$org/$threadId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatOrgChatRoute = ChatOrgChatRouteImport.update({
  id: '/$org/chat',
  path: '/$org/chat',
  getParentRoute: () => ChatRoute,
} as any)
const OrgAppsContractIntelligenceIndexRoute =
  OrgAppsContractIntelligenceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgAppsContractIntelligenceRoute,
  } as any)
const OrgAppsContractIntelligenceDocumentsRoute =
  OrgAppsContractIntelligenceDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => OrgAppsContractIntelligenceRoute,
  } as any)
const OrgAppsContractIntelligenceNewRoute =
  OrgAppsContractIntelligenceNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => OrgAppsContractIntelligenceRoute,
  } as any)
const OrgAppsContractIntelligenceSettingsRoute =
  OrgAppsContractIntelligenceSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => OrgAppsContractIntelligenceRoute,
  } as any)
const OrgAppsContractIntelligenceTemplatesRoute =
  OrgAppsContractIntelligenceTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => OrgAppsContractIntelligenceRoute,
  } as any)
const OrgAppsCustomServerIdRoute = OrgAppsCustomServerIdRouteImport.update({
  id: '/$org/apps/custom/$serverId',
  path: '/$org/apps/custom/$serverId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAppsImanageIndexRoute = OrgAppsImanageIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgAppsImanageRoute,
} as any)
const OrgAppsImanageAboutRoute = OrgAppsImanageAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => OrgAppsImanageRoute,
} as any)
const OrgAppsImanageFavoritesRoute = OrgAppsImanageFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => OrgAppsImanageRoute,
} as any)
const OrgAppsImanageRecentRoute = OrgAppsImanageRecentRouteImport.update({
  id: '/recent',
  path: '/recent',
  getParentRoute: () => OrgAppsImanageRoute,
} as any)
const OrgAppsImanageSavedRoute = OrgAppsImanageSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => OrgAppsImanageRoute,
} as any)
const OrgAppsImanageSearchRoute = OrgAppsImanageSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => OrgAppsImanageRoute,
} as any)
const OrgAppsImanageSettingsRoute = OrgAppsImanageSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgAppsImanageRoute,
} as any)
const OrgAppsProbeIndexRoute = OrgAppsProbeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgAppsProbeRoute,
} as any)
const OrgAppsProbeBriefingRoute = OrgAppsProbeBriefingRouteImport.update({
  id: '/briefing',
  path: '/briefing',
  getParentRoute: () => OrgAppsProbeRoute,
} as any)
const OrgAppsProbePracticeRoute = OrgAppsProbePracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => OrgAppsProbeRoute,
} as any)
const OrgComplianceFindingsIndexRoute =
  OrgComplianceFindingsIndexRouteImport.update({
    id: '/findings/',
    path: '/findings/',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgComplianceFindingsFindingIdRoute =
  OrgComplianceFindingsFindingIdRouteImport.update({
    id: '/findings/$findingId',
    path: '/findings/$findingId',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgComplianceFrameworksIndexRoute =
  OrgComplianceFrameworksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgComplianceFrameworksRoute,
  } as any)
const OrgComplianceFrameworksFrameworkIdRoute =
  OrgComplianceFrameworksFrameworkIdRouteImport.update({
    id: '/$frameworkId',
    path: '/$frameworkId',
    getParentRoute: () => OrgComplianceFrameworksRoute,
  } as any)
const OrgComplianceInspectorThreadIdRoute =
  OrgComplianceInspectorThreadIdRouteImport.update({
    id: '/inspector_/$threadId',
    path: '/inspector/$threadId',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgComplianceIntegrationsIntegrationIdRoute =
  OrgComplianceIntegrationsIntegrationIdRouteImport.update({
    id: '/integrations_/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgCompliancePoliciesIndexRoute =
  OrgCompliancePoliciesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgCompliancePoliciesRoute,
  } as any)
const OrgCompliancePoliciesPolicyIdRoute =
  OrgCompliancePoliciesPolicyIdRouteImport.update({
    id: '/$policyId',
    path: '/$policyId',
    getParentRoute: () => OrgCompliancePoliciesRoute,
  } as any)
const OrgComplianceRegimesRegimeIdRoute =
  OrgComplianceRegimesRegimeIdRouteImport.update({
    id: '/regimes_/$regimeId',
    path: '/regimes/$regimeId',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgComplianceSuggestionsRecommendationIdRoute =
  OrgComplianceSuggestionsRecommendationIdRouteImport.update({
    id: '/suggestions_/$recommendationId',
    path: '/suggestions/$recommendationId',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgConnectionsMcpServerIdRoute =
  OrgConnectionsMcpServerIdRouteImport.update({
    id: '/$org/connections_/mcp/$serverId',
    path: '/$org/connections/mcp/$serverId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ChatOrgDraftDraftIdRoute = ChatOrgDraftDraftIdRouteImport.update({
  id: '/$org/draft/$draftId',
  path: '/$org/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const OrgAppsContractIntelligenceReviewsIndexRoute =
  OrgAppsContractIntelligenceReviewsIndexRouteImport.update({
    id: '/reviews/',
    path: '/reviews/',
    getParentRoute: () => OrgAppsContractIntelligenceRoute,
  } as any)
const OrgAppsContractIntelligenceReviewsReviewIdRoute =
  OrgAppsContractIntelligenceReviewsReviewIdRouteImport.update({
    id: '/reviews/$reviewId',
    path: '/reviews/$reviewId',
    getParentRoute: () => OrgAppsContractIntelligenceRoute,
  } as any)
const OrgAppsImanageWWorkspaceIdRoute =
  OrgAppsImanageWWorkspaceIdRouteImport.update({
    id: '/w/$workspaceId',
    path: '/w/$workspaceId',
    getParentRoute: () => OrgAppsImanageRoute,
  } as any)
const OrgAppsProbeInterviewsIndexRoute =
  OrgAppsProbeInterviewsIndexRouteImport.update({
    id: '/interviews/',
    path: '/interviews/',
    getParentRoute: () => OrgAppsProbeRoute,
  } as any)
const OrgAppsProbeInterviewsSessionIdRoute =
  OrgAppsProbeInterviewsSessionIdRouteImport.update({
    id: '/interviews/$sessionId',
    path: '/interviews/$sessionId',
    getParentRoute: () => OrgAppsProbeRoute,
  } as any)
const OrgComplianceIntegrationsCustomServerIdRoute =
  OrgComplianceIntegrationsCustomServerIdRouteImport.update({
    id: '/integrations_/custom/$serverId',
    path: '/integrations/custom/$serverId',
    getParentRoute: () => OrgComplianceRoute,
  } as any)
const OrgAppsImanageWWorkspaceIdFolderIdRoute =
  OrgAppsImanageWWorkspaceIdFolderIdRouteImport.update({
    id: '/w/$workspaceId_/$folderId',
    path: '/w/$workspaceId/$folderId',
    getParentRoute: () => OrgAppsImanageRoute,
  } as any)
const OrgCompliancePoliciesPolicyIdVersionsVersionRoute =
  OrgCompliancePoliciesPolicyIdVersionsVersionRouteImport.update({
    id: '/$policyId_/versions/$version',
    path: '/$policyId/versions/$version',
    getParentRoute: () => OrgCompliancePoliciesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/automations': typeof AutomationsRoute
  '/compliance': typeof ComplianceRoute
  '/connect': typeof ConnectRoute
  '/connections': typeof ConnectionsRoute
  '/inbox': typeof InboxRoute
  '/library': typeof LibraryRoute
  '/pair': typeof PairRoute
  '/regulation': typeof RegulationRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/$org/agents': typeof OrgAgentsRoute
  '/$org/automations': typeof OrgAutomationsRoute
  '/$org/command-center': typeof OrgCommandCenterRoute
  '/$org/compliance': typeof OrgComplianceRouteWithChildren
  '/$org/connections': typeof OrgConnectionsRoute
  '/$org/inbox': typeof OrgInboxRoute
  '/$org/settings': typeof OrgSettingsRouteWithChildren
  '/$org/usage': typeof OrgUsageRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/connections/$pluginId': typeof ConnectionsPluginIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/usage': typeof SettingsUsageRoute
  '/settings/your-context': typeof SettingsYourContextRoute
  '/$org/apps/$appId': typeof OrgAppsAppIdRoute
  '/$org/apps/contract-intelligence': typeof OrgAppsContractIntelligenceRouteWithChildren
  '/$org/apps/imanage': typeof OrgAppsImanageRouteWithChildren
  '/$org/apps/probe': typeof OrgAppsProbeRouteWithChildren
  '/$org/compliance/frameworks': typeof OrgComplianceFrameworksRouteWithChildren
  '/$org/compliance/inspector': typeof OrgComplianceInspectorRoute
  '/$org/compliance/integrations': typeof OrgComplianceIntegrationsRoute
  '/$org/compliance/knowledge': typeof OrgComplianceKnowledgeRoute
  '/$org/compliance/policies': typeof OrgCompliancePoliciesRouteWithChildren
  '/$org/compliance/probe': typeof OrgComplianceProbeRoute
  '/$org/compliance/procedures': typeof OrgComplianceProceduresRoute
  '/$org/compliance/regimes': typeof OrgComplianceRegimesRoute
  '/$org/compliance/regulatory': typeof OrgComplianceRegulatoryRoute
  '/$org/compliance/suggestions': typeof OrgComplianceSuggestionsRoute
  '/$org/compliance/templates': typeof OrgComplianceTemplatesRoute
  '/$org/connections/$pluginId': typeof OrgConnectionsPluginIdRoute
  '/$org/regulation/$': typeof OrgRegulationSplatRoute
  '/$org/settings/$section': typeof OrgSettingsSectionRoute
  '/$org/skills/$slug': typeof OrgSkillsSlugRoute
  '/$org/spaces/$spaceId': typeof OrgSpacesSpaceIdRoute
  '/$org/workflows/$workflowId': typeof OrgWorkflowsWorkflowIdRoute
  '/$org/$threadId': typeof ChatOrgThreadIdRoute
  '/$org/chat': typeof ChatOrgChatRoute
  '/$org/apps/': typeof OrgAppsIndexRoute
  '/$org/compliance/': typeof OrgComplianceIndexRoute
  '/$org/regulation/': typeof OrgRegulationIndexRoute
  '/$org/skills/': typeof OrgSkillsIndexRoute
  '/$org/spaces/': typeof OrgSpacesIndexRoute
  '/$org/workflows/': typeof OrgWorkflowsIndexRoute
  '/$org/': typeof ChatOrgIndexRoute
  '/$org/apps/contract-intelligence/documents': typeof OrgAppsContractIntelligenceDocumentsRoute
  '/$org/apps/contract-intelligence/new': typeof OrgAppsContractIntelligenceNewRoute
  '/$org/apps/contract-intelligence/settings': typeof OrgAppsContractIntelligenceSettingsRoute
  '/$org/apps/contract-intelligence/templates': typeof OrgAppsContractIntelligenceTemplatesRoute
  '/$org/apps/custom/$serverId': typeof OrgAppsCustomServerIdRoute
  '/$org/apps/imanage/about': typeof OrgAppsImanageAboutRoute
  '/$org/apps/imanage/favorites': typeof OrgAppsImanageFavoritesRoute
  '/$org/apps/imanage/recent': typeof OrgAppsImanageRecentRoute
  '/$org/apps/imanage/saved': typeof OrgAppsImanageSavedRoute
  '/$org/apps/imanage/search': typeof OrgAppsImanageSearchRoute
  '/$org/apps/imanage/settings': typeof OrgAppsImanageSettingsRoute
  '/$org/apps/probe/briefing': typeof OrgAppsProbeBriefingRoute
  '/$org/apps/probe/practice': typeof OrgAppsProbePracticeRoute
  '/$org/compliance/findings/$findingId': typeof OrgComplianceFindingsFindingIdRoute
  '/$org/compliance/frameworks/$frameworkId': typeof OrgComplianceFrameworksFrameworkIdRoute
  '/$org/compliance/inspector/$threadId': typeof OrgComplianceInspectorThreadIdRoute
  '/$org/compliance/integrations/$integrationId': typeof OrgComplianceIntegrationsIntegrationIdRoute
  '/$org/compliance/policies/$policyId': typeof OrgCompliancePoliciesPolicyIdRoute
  '/$org/compliance/regimes/$regimeId': typeof OrgComplianceRegimesRegimeIdRoute
  '/$org/compliance/suggestions/$recommendationId': typeof OrgComplianceSuggestionsRecommendationIdRoute
  '/$org/connections/mcp/$serverId': typeof OrgConnectionsMcpServerIdRoute
  '/$org/draft/$draftId': typeof ChatOrgDraftDraftIdRoute
  '/$org/apps/contract-intelligence/': typeof OrgAppsContractIntelligenceIndexRoute
  '/$org/apps/imanage/': typeof OrgAppsImanageIndexRoute
  '/$org/apps/probe/': typeof OrgAppsProbeIndexRoute
  '/$org/compliance/findings/': typeof OrgComplianceFindingsIndexRoute
  '/$org/compliance/frameworks/': typeof OrgComplianceFrameworksIndexRoute
  '/$org/compliance/policies/': typeof OrgCompliancePoliciesIndexRoute
  '/$org/apps/contract-intelligence/reviews/$reviewId': typeof OrgAppsContractIntelligenceReviewsReviewIdRoute
  '/$org/apps/imanage/w/$workspaceId': typeof OrgAppsImanageWWorkspaceIdRoute
  '/$org/apps/probe/interviews/$sessionId': typeof OrgAppsProbeInterviewsSessionIdRoute
  '/$org/compliance/integrations/custom/$serverId': typeof OrgComplianceIntegrationsCustomServerIdRoute
  '/$org/apps/contract-intelligence/reviews/': typeof OrgAppsContractIntelligenceReviewsIndexRoute
  '/$org/apps/probe/interviews/': typeof OrgAppsProbeInterviewsIndexRoute
  '/$org/apps/imanage/w/$workspaceId/$folderId': typeof OrgAppsImanageWWorkspaceIdFolderIdRoute
  '/$org/compliance/policies/$policyId/versions/$version': typeof OrgCompliancePoliciesPolicyIdVersionsVersionRoute
}
export interface FileRoutesByTo {
  '/automations': typeof AutomationsRoute
  '/compliance': typeof ComplianceRoute
  '/connect': typeof ConnectRoute
  '/connections': typeof ConnectionsRoute
  '/inbox': typeof InboxRoute
  '/library': typeof LibraryRoute
  '/pair': typeof PairRoute
  '/regulation': typeof RegulationRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/$org/agents': typeof OrgAgentsRoute
  '/$org/automations': typeof OrgAutomationsRoute
  '/$org/command-center': typeof OrgCommandCenterRoute
  '/$org/connections': typeof OrgConnectionsRoute
  '/$org/inbox': typeof OrgInboxRoute
  '/$org/settings': typeof OrgSettingsRouteWithChildren
  '/$org/usage': typeof OrgUsageRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/connections/$pluginId': typeof ConnectionsPluginIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/usage': typeof SettingsUsageRoute
  '/settings/your-context': typeof SettingsYourContextRoute
  '/': typeof ChatIndexRoute
  '/$org/apps/$appId': typeof OrgAppsAppIdRoute
  '/$org/compliance/inspector': typeof OrgComplianceInspectorRoute
  '/$org/compliance/integrations': typeof OrgComplianceIntegrationsRoute
  '/$org/compliance/knowledge': typeof OrgComplianceKnowledgeRoute
  '/$org/compliance/probe': typeof OrgComplianceProbeRoute
  '/$org/compliance/procedures': typeof OrgComplianceProceduresRoute
  '/$org/compliance/regimes': typeof OrgComplianceRegimesRoute
  '/$org/compliance/regulatory': typeof OrgComplianceRegulatoryRoute
  '/$org/compliance/suggestions': typeof OrgComplianceSuggestionsRoute
  '/$org/compliance/templates': typeof OrgComplianceTemplatesRoute
  '/$org/connections/$pluginId': typeof OrgConnectionsPluginIdRoute
  '/$org/regulation/$': typeof OrgRegulationSplatRoute
  '/$org/settings/$section': typeof OrgSettingsSectionRoute
  '/$org/skills/$slug': typeof OrgSkillsSlugRoute
  '/$org/spaces/$spaceId': typeof OrgSpacesSpaceIdRoute
  '/$org/workflows/$workflowId': typeof OrgWorkflowsWorkflowIdRoute
  '/$org/$threadId': typeof ChatOrgThreadIdRoute
  '/$org/chat': typeof ChatOrgChatRoute
  '/$org/apps': typeof OrgAppsIndexRoute
  '/$org/compliance': typeof OrgComplianceIndexRoute
  '/$org/regulation': typeof OrgRegulationIndexRoute
  '/$org/skills': typeof OrgSkillsIndexRoute
  '/$org/spaces': typeof OrgSpacesIndexRoute
  '/$org/workflows': typeof OrgWorkflowsIndexRoute
  '/$org': typeof ChatOrgIndexRoute
  '/$org/apps/contract-intelligence/documents': typeof OrgAppsContractIntelligenceDocumentsRoute
  '/$org/apps/contract-intelligence/new': typeof OrgAppsContractIntelligenceNewRoute
  '/$org/apps/contract-intelligence/settings': typeof OrgAppsContractIntelligenceSettingsRoute
  '/$org/apps/contract-intelligence/templates': typeof OrgAppsContractIntelligenceTemplatesRoute
  '/$org/apps/custom/$serverId': typeof OrgAppsCustomServerIdRoute
  '/$org/apps/imanage/about': typeof OrgAppsImanageAboutRoute
  '/$org/apps/imanage/favorites': typeof OrgAppsImanageFavoritesRoute
  '/$org/apps/imanage/recent': typeof OrgAppsImanageRecentRoute
  '/$org/apps/imanage/saved': typeof OrgAppsImanageSavedRoute
  '/$org/apps/imanage/search': typeof OrgAppsImanageSearchRoute
  '/$org/apps/imanage/settings': typeof OrgAppsImanageSettingsRoute
  '/$org/apps/probe/briefing': typeof OrgAppsProbeBriefingRoute
  '/$org/apps/probe/practice': typeof OrgAppsProbePracticeRoute
  '/$org/compliance/findings/$findingId': typeof OrgComplianceFindingsFindingIdRoute
  '/$org/compliance/frameworks/$frameworkId': typeof OrgComplianceFrameworksFrameworkIdRoute
  '/$org/compliance/inspector/$threadId': typeof OrgComplianceInspectorThreadIdRoute
  '/$org/compliance/integrations/$integrationId': typeof OrgComplianceIntegrationsIntegrationIdRoute
  '/$org/compliance/policies/$policyId': typeof OrgCompliancePoliciesPolicyIdRoute
  '/$org/compliance/regimes/$regimeId': typeof OrgComplianceRegimesRegimeIdRoute
  '/$org/compliance/suggestions/$recommendationId': typeof OrgComplianceSuggestionsRecommendationIdRoute
  '/$org/connections/mcp/$serverId': typeof OrgConnectionsMcpServerIdRoute
  '/$org/draft/$draftId': typeof ChatOrgDraftDraftIdRoute
  '/$org/apps/contract-intelligence': typeof OrgAppsContractIntelligenceIndexRoute
  '/$org/apps/imanage': typeof OrgAppsImanageIndexRoute
  '/$org/apps/probe': typeof OrgAppsProbeIndexRoute
  '/$org/compliance/findings': typeof OrgComplianceFindingsIndexRoute
  '/$org/compliance/frameworks': typeof OrgComplianceFrameworksIndexRoute
  '/$org/compliance/policies': typeof OrgCompliancePoliciesIndexRoute
  '/$org/apps/contract-intelligence/reviews/$reviewId': typeof OrgAppsContractIntelligenceReviewsReviewIdRoute
  '/$org/apps/imanage/w/$workspaceId': typeof OrgAppsImanageWWorkspaceIdRoute
  '/$org/apps/probe/interviews/$sessionId': typeof OrgAppsProbeInterviewsSessionIdRoute
  '/$org/compliance/integrations/custom/$serverId': typeof OrgComplianceIntegrationsCustomServerIdRoute
  '/$org/apps/contract-intelligence/reviews': typeof OrgAppsContractIntelligenceReviewsIndexRoute
  '/$org/apps/probe/interviews': typeof OrgAppsProbeInterviewsIndexRoute
  '/$org/apps/imanage/w/$workspaceId/$folderId': typeof OrgAppsImanageWWorkspaceIdFolderIdRoute
  '/$org/compliance/policies/$policyId/versions/$version': typeof OrgCompliancePoliciesPolicyIdVersionsVersionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/automations': typeof AutomationsRoute
  '/compliance': typeof ComplianceRoute
  '/connect': typeof ConnectRoute
  '/connections': typeof ConnectionsRoute
  '/inbox': typeof InboxRoute
  '/library': typeof LibraryRoute
  '/pair': typeof PairRoute
  '/regulation': typeof RegulationRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/$org/agents': typeof OrgAgentsRoute
  '/$org/automations': typeof OrgAutomationsRoute
  '/$org/command-center': typeof OrgCommandCenterRoute
  '/$org/compliance': typeof OrgComplianceRouteWithChildren
  '/$org/connections': typeof OrgConnectionsRoute
  '/$org/inbox': typeof OrgInboxRoute
  '/$org/settings': typeof OrgSettingsRouteWithChildren
  '/$org/usage': typeof OrgUsageRoute
  '/connect_/callback': typeof ConnectCallbackRoute
  '/connections_/$pluginId': typeof ConnectionsPluginIdRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/usage': typeof SettingsUsageRoute
  '/settings/your-context': typeof SettingsYourContextRoute
  '/_chat/': typeof ChatIndexRoute
  '/$org/apps/$appId': typeof OrgAppsAppIdRoute
  '/$org/apps/contract-intelligence': typeof OrgAppsContractIntelligenceRouteWithChildren
  '/$org/apps/imanage': typeof OrgAppsImanageRouteWithChildren
  '/$org/apps/probe': typeof OrgAppsProbeRouteWithChildren
  '/$org/compliance/frameworks': typeof OrgComplianceFrameworksRouteWithChildren
  '/$org/compliance/inspector': typeof OrgComplianceInspectorRoute
  '/$org/compliance/integrations': typeof OrgComplianceIntegrationsRoute
  '/$org/compliance/knowledge': typeof OrgComplianceKnowledgeRoute
  '/$org/compliance/policies': typeof OrgCompliancePoliciesRouteWithChildren
  '/$org/compliance/probe': typeof OrgComplianceProbeRoute
  '/$org/compliance/procedures': typeof OrgComplianceProceduresRoute
  '/$org/compliance/regimes': typeof OrgComplianceRegimesRoute
  '/$org/compliance/regulatory': typeof OrgComplianceRegulatoryRoute
  '/$org/compliance/suggestions': typeof OrgComplianceSuggestionsRoute
  '/$org/compliance/templates': typeof OrgComplianceTemplatesRoute
  '/$org/connections_/$pluginId': typeof OrgConnectionsPluginIdRoute
  '/$org/regulation/$': typeof OrgRegulationSplatRoute
  '/$org/settings/$section': typeof OrgSettingsSectionRoute
  '/$org/skills/$slug': typeof OrgSkillsSlugRoute
  '/$org/spaces/$spaceId': typeof OrgSpacesSpaceIdRoute
  '/$org/workflows/$workflowId': typeof OrgWorkflowsWorkflowIdRoute
  '/_chat/$org/$threadId': typeof ChatOrgThreadIdRoute
  '/_chat/$org/chat': typeof ChatOrgChatRoute
  '/$org/apps/': typeof OrgAppsIndexRoute
  '/$org/compliance/': typeof OrgComplianceIndexRoute
  '/$org/regulation/': typeof OrgRegulationIndexRoute
  '/$org/skills/': typeof OrgSkillsIndexRoute
  '/$org/spaces/': typeof OrgSpacesIndexRoute
  '/$org/workflows/': typeof OrgWorkflowsIndexRoute
  '/_chat/$org/': typeof ChatOrgIndexRoute
  '/$org/apps/contract-intelligence/documents': typeof OrgAppsContractIntelligenceDocumentsRoute
  '/$org/apps/contract-intelligence/new': typeof OrgAppsContractIntelligenceNewRoute
  '/$org/apps/contract-intelligence/settings': typeof OrgAppsContractIntelligenceSettingsRoute
  '/$org/apps/contract-intelligence/templates': typeof OrgAppsContractIntelligenceTemplatesRoute
  '/$org/apps/custom/$serverId': typeof OrgAppsCustomServerIdRoute
  '/$org/apps/imanage/about': typeof OrgAppsImanageAboutRoute
  '/$org/apps/imanage/favorites': typeof OrgAppsImanageFavoritesRoute
  '/$org/apps/imanage/recent': typeof OrgAppsImanageRecentRoute
  '/$org/apps/imanage/saved': typeof OrgAppsImanageSavedRoute
  '/$org/apps/imanage/search': typeof OrgAppsImanageSearchRoute
  '/$org/apps/imanage/settings': typeof OrgAppsImanageSettingsRoute
  '/$org/apps/probe/briefing': typeof OrgAppsProbeBriefingRoute
  '/$org/apps/probe/practice': typeof OrgAppsProbePracticeRoute
  '/$org/compliance/findings/$findingId': typeof OrgComplianceFindingsFindingIdRoute
  '/$org/compliance/frameworks/$frameworkId': typeof OrgComplianceFrameworksFrameworkIdRoute
  '/$org/compliance/inspector_/$threadId': typeof OrgComplianceInspectorThreadIdRoute
  '/$org/compliance/integrations_/$integrationId': typeof OrgComplianceIntegrationsIntegrationIdRoute
  '/$org/compliance/policies/$policyId': typeof OrgCompliancePoliciesPolicyIdRoute
  '/$org/compliance/regimes_/$regimeId': typeof OrgComplianceRegimesRegimeIdRoute
  '/$org/compliance/suggestions_/$recommendationId': typeof OrgComplianceSuggestionsRecommendationIdRoute
  '/$org/connections_/mcp/$serverId': typeof OrgConnectionsMcpServerIdRoute
  '/_chat/$org/draft/$draftId': typeof ChatOrgDraftDraftIdRoute
  '/$org/apps/contract-intelligence/': typeof OrgAppsContractIntelligenceIndexRoute
  '/$org/apps/imanage/': typeof OrgAppsImanageIndexRoute
  '/$org/apps/probe/': typeof OrgAppsProbeIndexRoute
  '/$org/compliance/findings/': typeof OrgComplianceFindingsIndexRoute
  '/$org/compliance/frameworks/': typeof OrgComplianceFrameworksIndexRoute
  '/$org/compliance/policies/': typeof OrgCompliancePoliciesIndexRoute
  '/$org/apps/contract-intelligence/reviews/$reviewId': typeof OrgAppsContractIntelligenceReviewsReviewIdRoute
  '/$org/apps/imanage/w/$workspaceId': typeof OrgAppsImanageWWorkspaceIdRoute
  '/$org/apps/probe/interviews/$sessionId': typeof OrgAppsProbeInterviewsSessionIdRoute
  '/$org/compliance/integrations_/custom/$serverId': typeof OrgComplianceIntegrationsCustomServerIdRoute
  '/$org/apps/contract-intelligence/reviews/': typeof OrgAppsContractIntelligenceReviewsIndexRoute
  '/$org/apps/probe/interviews/': typeof OrgAppsProbeInterviewsIndexRoute
  '/$org/apps/imanage/w/$workspaceId_/$folderId': typeof OrgAppsImanageWWorkspaceIdFolderIdRoute
  '/$org/compliance/policies/$policyId_/versions/$version': typeof OrgCompliancePoliciesPolicyIdVersionsVersionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/automations'
    | '/compliance'
    | '/connect'
    | '/connections'
    | '/inbox'
    | '/library'
    | '/pair'
    | '/regulation'
    | '/settings'
    | '/usage'
    | '/$org/agents'
    | '/$org/automations'
    | '/$org/command-center'
    | '/$org/compliance'
    | '/$org/connections'
    | '/$org/inbox'
    | '/$org/settings'
    | '/$org/usage'
    | '/connect/callback'
    | '/connections/$pluginId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/branding'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/security'
    | '/settings/usage'
    | '/settings/your-context'
    | '/$org/apps/$appId'
    | '/$org/apps/contract-intelligence'
    | '/$org/apps/imanage'
    | '/$org/apps/probe'
    | '/$org/compliance/frameworks'
    | '/$org/compliance/inspector'
    | '/$org/compliance/integrations'
    | '/$org/compliance/knowledge'
    | '/$org/compliance/policies'
    | '/$org/compliance/probe'
    | '/$org/compliance/procedures'
    | '/$org/compliance/regimes'
    | '/$org/compliance/regulatory'
    | '/$org/compliance/suggestions'
    | '/$org/compliance/templates'
    | '/$org/connections/$pluginId'
    | '/$org/regulation/$'
    | '/$org/settings/$section'
    | '/$org/skills/$slug'
    | '/$org/spaces/$spaceId'
    | '/$org/workflows/$workflowId'
    | '/$org/$threadId'
    | '/$org/chat'
    | '/$org/apps/'
    | '/$org/compliance/'
    | '/$org/regulation/'
    | '/$org/skills/'
    | '/$org/spaces/'
    | '/$org/workflows/'
    | '/$org/'
    | '/$org/apps/contract-intelligence/documents'
    | '/$org/apps/contract-intelligence/new'
    | '/$org/apps/contract-intelligence/settings'
    | '/$org/apps/contract-intelligence/templates'
    | '/$org/apps/custom/$serverId'
    | '/$org/apps/imanage/about'
    | '/$org/apps/imanage/favorites'
    | '/$org/apps/imanage/recent'
    | '/$org/apps/imanage/saved'
    | '/$org/apps/imanage/search'
    | '/$org/apps/imanage/settings'
    | '/$org/apps/probe/briefing'
    | '/$org/apps/probe/practice'
    | '/$org/compliance/findings/$findingId'
    | '/$org/compliance/frameworks/$frameworkId'
    | '/$org/compliance/inspector/$threadId'
    | '/$org/compliance/integrations/$integrationId'
    | '/$org/compliance/policies/$policyId'
    | '/$org/compliance/regimes/$regimeId'
    | '/$org/compliance/suggestions/$recommendationId'
    | '/$org/connections/mcp/$serverId'
    | '/$org/draft/$draftId'
    | '/$org/apps/contract-intelligence/'
    | '/$org/apps/imanage/'
    | '/$org/apps/probe/'
    | '/$org/compliance/findings/'
    | '/$org/compliance/frameworks/'
    | '/$org/compliance/policies/'
    | '/$org/apps/contract-intelligence/reviews/$reviewId'
    | '/$org/apps/imanage/w/$workspaceId'
    | '/$org/apps/probe/interviews/$sessionId'
    | '/$org/compliance/integrations/custom/$serverId'
    | '/$org/apps/contract-intelligence/reviews/'
    | '/$org/apps/probe/interviews/'
    | '/$org/apps/imanage/w/$workspaceId/$folderId'
    | '/$org/compliance/policies/$policyId/versions/$version'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/automations'
    | '/compliance'
    | '/connect'
    | '/connections'
    | '/inbox'
    | '/library'
    | '/pair'
    | '/regulation'
    | '/settings'
    | '/usage'
    | '/$org/agents'
    | '/$org/automations'
    | '/$org/command-center'
    | '/$org/connections'
    | '/$org/inbox'
    | '/$org/settings'
    | '/$org/usage'
    | '/connect/callback'
    | '/connections/$pluginId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/branding'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/security'
    | '/settings/usage'
    | '/settings/your-context'
    | '/'
    | '/$org/apps/$appId'
    | '/$org/compliance/inspector'
    | '/$org/compliance/integrations'
    | '/$org/compliance/knowledge'
    | '/$org/compliance/probe'
    | '/$org/compliance/procedures'
    | '/$org/compliance/regimes'
    | '/$org/compliance/regulatory'
    | '/$org/compliance/suggestions'
    | '/$org/compliance/templates'
    | '/$org/connections/$pluginId'
    | '/$org/regulation/$'
    | '/$org/settings/$section'
    | '/$org/skills/$slug'
    | '/$org/spaces/$spaceId'
    | '/$org/workflows/$workflowId'
    | '/$org/$threadId'
    | '/$org/chat'
    | '/$org/apps'
    | '/$org/compliance'
    | '/$org/regulation'
    | '/$org/skills'
    | '/$org/spaces'
    | '/$org/workflows'
    | '/$org'
    | '/$org/apps/contract-intelligence/documents'
    | '/$org/apps/contract-intelligence/new'
    | '/$org/apps/contract-intelligence/settings'
    | '/$org/apps/contract-intelligence/templates'
    | '/$org/apps/custom/$serverId'
    | '/$org/apps/imanage/about'
    | '/$org/apps/imanage/favorites'
    | '/$org/apps/imanage/recent'
    | '/$org/apps/imanage/saved'
    | '/$org/apps/imanage/search'
    | '/$org/apps/imanage/settings'
    | '/$org/apps/probe/briefing'
    | '/$org/apps/probe/practice'
    | '/$org/compliance/findings/$findingId'
    | '/$org/compliance/frameworks/$frameworkId'
    | '/$org/compliance/inspector/$threadId'
    | '/$org/compliance/integrations/$integrationId'
    | '/$org/compliance/policies/$policyId'
    | '/$org/compliance/regimes/$regimeId'
    | '/$org/compliance/suggestions/$recommendationId'
    | '/$org/connections/mcp/$serverId'
    | '/$org/draft/$draftId'
    | '/$org/apps/contract-intelligence'
    | '/$org/apps/imanage'
    | '/$org/apps/probe'
    | '/$org/compliance/findings'
    | '/$org/compliance/frameworks'
    | '/$org/compliance/policies'
    | '/$org/apps/contract-intelligence/reviews/$reviewId'
    | '/$org/apps/imanage/w/$workspaceId'
    | '/$org/apps/probe/interviews/$sessionId'
    | '/$org/compliance/integrations/custom/$serverId'
    | '/$org/apps/contract-intelligence/reviews'
    | '/$org/apps/probe/interviews'
    | '/$org/apps/imanage/w/$workspaceId/$folderId'
    | '/$org/compliance/policies/$policyId/versions/$version'
  id:
    | '__root__'
    | '/_chat'
    | '/automations'
    | '/compliance'
    | '/connect'
    | '/connections'
    | '/inbox'
    | '/library'
    | '/pair'
    | '/regulation'
    | '/settings'
    | '/usage'
    | '/$org/agents'
    | '/$org/automations'
    | '/$org/command-center'
    | '/$org/compliance'
    | '/$org/connections'
    | '/$org/inbox'
    | '/$org/settings'
    | '/$org/usage'
    | '/connect_/callback'
    | '/connections_/$pluginId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/branding'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/security'
    | '/settings/usage'
    | '/settings/your-context'
    | '/_chat/'
    | '/$org/apps/$appId'
    | '/$org/apps/contract-intelligence'
    | '/$org/apps/imanage'
    | '/$org/apps/probe'
    | '/$org/compliance/frameworks'
    | '/$org/compliance/inspector'
    | '/$org/compliance/integrations'
    | '/$org/compliance/knowledge'
    | '/$org/compliance/policies'
    | '/$org/compliance/probe'
    | '/$org/compliance/procedures'
    | '/$org/compliance/regimes'
    | '/$org/compliance/regulatory'
    | '/$org/compliance/suggestions'
    | '/$org/compliance/templates'
    | '/$org/connections_/$pluginId'
    | '/$org/regulation/$'
    | '/$org/settings/$section'
    | '/$org/skills/$slug'
    | '/$org/spaces/$spaceId'
    | '/$org/workflows/$workflowId'
    | '/_chat/$org/$threadId'
    | '/_chat/$org/chat'
    | '/$org/apps/'
    | '/$org/compliance/'
    | '/$org/regulation/'
    | '/$org/skills/'
    | '/$org/spaces/'
    | '/$org/workflows/'
    | '/_chat/$org/'
    | '/$org/apps/contract-intelligence/documents'
    | '/$org/apps/contract-intelligence/new'
    | '/$org/apps/contract-intelligence/settings'
    | '/$org/apps/contract-intelligence/templates'
    | '/$org/apps/custom/$serverId'
    | '/$org/apps/imanage/about'
    | '/$org/apps/imanage/favorites'
    | '/$org/apps/imanage/recent'
    | '/$org/apps/imanage/saved'
    | '/$org/apps/imanage/search'
    | '/$org/apps/imanage/settings'
    | '/$org/apps/probe/briefing'
    | '/$org/apps/probe/practice'
    | '/$org/compliance/findings/$findingId'
    | '/$org/compliance/frameworks/$frameworkId'
    | '/$org/compliance/inspector_/$threadId'
    | '/$org/compliance/integrations_/$integrationId'
    | '/$org/compliance/policies/$policyId'
    | '/$org/compliance/regimes_/$regimeId'
    | '/$org/compliance/suggestions_/$recommendationId'
    | '/$org/connections_/mcp/$serverId'
    | '/_chat/$org/draft/$draftId'
    | '/$org/apps/contract-intelligence/'
    | '/$org/apps/imanage/'
    | '/$org/apps/probe/'
    | '/$org/compliance/findings/'
    | '/$org/compliance/frameworks/'
    | '/$org/compliance/policies/'
    | '/$org/apps/contract-intelligence/reviews/$reviewId'
    | '/$org/apps/imanage/w/$workspaceId'
    | '/$org/apps/probe/interviews/$sessionId'
    | '/$org/compliance/integrations_/custom/$serverId'
    | '/$org/apps/contract-intelligence/reviews/'
    | '/$org/apps/probe/interviews/'
    | '/$org/apps/imanage/w/$workspaceId_/$folderId'
    | '/$org/compliance/policies/$policyId_/versions/$version'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  AutomationsRoute: typeof AutomationsRoute
  ComplianceRoute: typeof ComplianceRoute
  ConnectRoute: typeof ConnectRoute
  ConnectionsRoute: typeof ConnectionsRoute
  InboxRoute: typeof InboxRoute
  LibraryRoute: typeof LibraryRoute
  PairRoute: typeof PairRoute
  RegulationRoute: typeof RegulationRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  UsageRoute: typeof UsageRoute
  OrgAgentsRoute: typeof OrgAgentsRoute
  OrgAutomationsRoute: typeof OrgAutomationsRoute
  OrgCommandCenterRoute: typeof OrgCommandCenterRoute
  OrgComplianceRoute: typeof OrgComplianceRouteWithChildren
  OrgConnectionsRoute: typeof OrgConnectionsRoute
  OrgInboxRoute: typeof OrgInboxRoute
  OrgSettingsRoute: typeof OrgSettingsRouteWithChildren
  OrgUsageRoute: typeof OrgUsageRoute
  ConnectCallbackRoute: typeof ConnectCallbackRoute
  ConnectionsPluginIdRoute: typeof ConnectionsPluginIdRoute
  OrgAppsAppIdRoute: typeof OrgAppsAppIdRoute
  OrgAppsContractIntelligenceRoute: typeof OrgAppsContractIntelligenceRouteWithChildren
  OrgAppsImanageRoute: typeof OrgAppsImanageRouteWithChildren
  OrgAppsProbeRoute: typeof OrgAppsProbeRouteWithChildren
  OrgConnectionsPluginIdRoute: typeof OrgConnectionsPluginIdRoute
  OrgRegulationSplatRoute: typeof OrgRegulationSplatRoute
  OrgSkillsSlugRoute: typeof OrgSkillsSlugRoute
  OrgSpacesSpaceIdRoute: typeof OrgSpacesSpaceIdRoute
  OrgWorkflowsWorkflowIdRoute: typeof OrgWorkflowsWorkflowIdRoute
  OrgAppsIndexRoute: typeof OrgAppsIndexRoute
  OrgRegulationIndexRoute: typeof OrgRegulationIndexRoute
  OrgSkillsIndexRoute: typeof OrgSkillsIndexRoute
  OrgSpacesIndexRoute: typeof OrgSpacesIndexRoute
  OrgWorkflowsIndexRoute: typeof OrgWorkflowsIndexRoute
  OrgAppsCustomServerIdRoute: typeof OrgAppsCustomServerIdRoute
  OrgConnectionsMcpServerIdRoute: typeof OrgConnectionsMcpServerIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations': {
      id: '/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AutomationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connections': {
      id: '/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/regulation': {
      id: '/regulation'
      path: '/regulation'
      fullPath: '/regulation'
      preLoaderRoute: typeof RegulationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/agents': {
      id: '/$org/agents'
      path: '/$org/agents'
      fullPath: '/$org/agents'
      preLoaderRoute: typeof OrgAgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/automations': {
      id: '/$org/automations'
      path: '/$org/automations'
      fullPath: '/$org/automations'
      preLoaderRoute: typeof OrgAutomationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/command-center': {
      id: '/$org/command-center'
      path: '/$org/command-center'
      fullPath: '/$org/command-center'
      preLoaderRoute: typeof OrgCommandCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/compliance': {
      id: '/$org/compliance'
      path: '/$org/compliance'
      fullPath: '/$org/compliance'
      preLoaderRoute: typeof OrgComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/connections': {
      id: '/$org/connections'
      path: '/$org/connections'
      fullPath: '/$org/connections'
      preLoaderRoute: typeof OrgConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/inbox': {
      id: '/$org/inbox'
      path: '/$org/inbox'
      fullPath: '/$org/inbox'
      preLoaderRoute: typeof OrgInboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/settings': {
      id: '/$org/settings'
      path: '/$org/settings'
      fullPath: '/$org/settings'
      preLoaderRoute: typeof OrgSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/usage': {
      id: '/$org/usage'
      path: '/$org/usage'
      fullPath: '/$org/usage'
      preLoaderRoute: typeof OrgUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/connect_/callback': {
      id: '/connect_/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connections_/$pluginId': {
      id: '/connections_/$pluginId'
      path: '/connections/$pluginId'
      fullPath: '/connections/$pluginId'
      preLoaderRoute: typeof ConnectionsPluginIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/branding': {
      id: '/settings/branding'
      path: '/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof SettingsBrandingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/members': {
      id: '/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof SettingsMembersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/usage': {
      id: '/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof SettingsUsageRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/your-context': {
      id: '/settings/your-context'
      path: '/your-context'
      fullPath: '/settings/your-context'
      preLoaderRoute: typeof SettingsYourContextRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/$org/apps/': {
      id: '/$org/apps/'
      path: '/$org/apps'
      fullPath: '/$org/apps/'
      preLoaderRoute: typeof OrgAppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/apps/$appId': {
      id: '/$org/apps/$appId'
      path: '/$org/apps/$appId'
      fullPath: '/$org/apps/$appId'
      preLoaderRoute: typeof OrgAppsAppIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/apps/contract-intelligence': {
      id: '/$org/apps/contract-intelligence'
      path: '/$org/apps/contract-intelligence'
      fullPath: '/$org/apps/contract-intelligence'
      preLoaderRoute: typeof OrgAppsContractIntelligenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/apps/imanage': {
      id: '/$org/apps/imanage'
      path: '/$org/apps/imanage'
      fullPath: '/$org/apps/imanage'
      preLoaderRoute: typeof OrgAppsImanageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/apps/probe': {
      id: '/$org/apps/probe'
      path: '/$org/apps/probe'
      fullPath: '/$org/apps/probe'
      preLoaderRoute: typeof OrgAppsProbeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/compliance/': {
      id: '/$org/compliance/'
      path: '/'
      fullPath: '/$org/compliance/'
      preLoaderRoute: typeof OrgComplianceIndexRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/frameworks': {
      id: '/$org/compliance/frameworks'
      path: '/frameworks'
      fullPath: '/$org/compliance/frameworks'
      preLoaderRoute: typeof OrgComplianceFrameworksRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/inspector': {
      id: '/$org/compliance/inspector'
      path: '/inspector'
      fullPath: '/$org/compliance/inspector'
      preLoaderRoute: typeof OrgComplianceInspectorRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/integrations': {
      id: '/$org/compliance/integrations'
      path: '/integrations'
      fullPath: '/$org/compliance/integrations'
      preLoaderRoute: typeof OrgComplianceIntegrationsRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/knowledge': {
      id: '/$org/compliance/knowledge'
      path: '/knowledge'
      fullPath: '/$org/compliance/knowledge'
      preLoaderRoute: typeof OrgComplianceKnowledgeRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/policies': {
      id: '/$org/compliance/policies'
      path: '/policies'
      fullPath: '/$org/compliance/policies'
      preLoaderRoute: typeof OrgCompliancePoliciesRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/probe': {
      id: '/$org/compliance/probe'
      path: '/probe'
      fullPath: '/$org/compliance/probe'
      preLoaderRoute: typeof OrgComplianceProbeRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/procedures': {
      id: '/$org/compliance/procedures'
      path: '/procedures'
      fullPath: '/$org/compliance/procedures'
      preLoaderRoute: typeof OrgComplianceProceduresRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/regimes': {
      id: '/$org/compliance/regimes'
      path: '/regimes'
      fullPath: '/$org/compliance/regimes'
      preLoaderRoute: typeof OrgComplianceRegimesRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/regulatory': {
      id: '/$org/compliance/regulatory'
      path: '/regulatory'
      fullPath: '/$org/compliance/regulatory'
      preLoaderRoute: typeof OrgComplianceRegulatoryRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/suggestions': {
      id: '/$org/compliance/suggestions'
      path: '/suggestions'
      fullPath: '/$org/compliance/suggestions'
      preLoaderRoute: typeof OrgComplianceSuggestionsRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/templates': {
      id: '/$org/compliance/templates'
      path: '/templates'
      fullPath: '/$org/compliance/templates'
      preLoaderRoute: typeof OrgComplianceTemplatesRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/connections_/$pluginId': {
      id: '/$org/connections_/$pluginId'
      path: '/$org/connections/$pluginId'
      fullPath: '/$org/connections/$pluginId'
      preLoaderRoute: typeof OrgConnectionsPluginIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/regulation/': {
      id: '/$org/regulation/'
      path: '/$org/regulation'
      fullPath: '/$org/regulation/'
      preLoaderRoute: typeof OrgRegulationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/regulation/$': {
      id: '/$org/regulation/$'
      path: '/$org/regulation/$'
      fullPath: '/$org/regulation/$'
      preLoaderRoute: typeof OrgRegulationSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/settings/$section': {
      id: '/$org/settings/$section'
      path: '/$section'
      fullPath: '/$org/settings/$section'
      preLoaderRoute: typeof OrgSettingsSectionRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/skills/': {
      id: '/$org/skills/'
      path: '/$org/skills'
      fullPath: '/$org/skills/'
      preLoaderRoute: typeof OrgSkillsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/skills/$slug': {
      id: '/$org/skills/$slug'
      path: '/$org/skills/$slug'
      fullPath: '/$org/skills/$slug'
      preLoaderRoute: typeof OrgSkillsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/spaces/': {
      id: '/$org/spaces/'
      path: '/$org/spaces'
      fullPath: '/$org/spaces/'
      preLoaderRoute: typeof OrgSpacesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/spaces/$spaceId': {
      id: '/$org/spaces/$spaceId'
      path: '/$org/spaces/$spaceId'
      fullPath: '/$org/spaces/$spaceId'
      preLoaderRoute: typeof OrgSpacesSpaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/workflows/': {
      id: '/$org/workflows/'
      path: '/$org/workflows'
      fullPath: '/$org/workflows/'
      preLoaderRoute: typeof OrgWorkflowsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/workflows/$workflowId': {
      id: '/$org/workflows/$workflowId'
      path: '/$org/workflows/$workflowId'
      fullPath: '/$org/workflows/$workflowId'
      preLoaderRoute: typeof OrgWorkflowsWorkflowIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/$org/': {
      id: '/_chat/$org/'
      path: '/$org'
      fullPath: '/$org/'
      preLoaderRoute: typeof ChatOrgIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$org/$threadId': {
      id: '/_chat/$org/$threadId'
      path: '/$org/$threadId'
      fullPath: '/$org/$threadId'
      preLoaderRoute: typeof ChatOrgThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$org/chat': {
      id: '/_chat/$org/chat'
      path: '/$org/chat'
      fullPath: '/$org/chat'
      preLoaderRoute: typeof ChatOrgChatRouteImport
      parentRoute: typeof ChatRoute
    }
    '/$org/apps/contract-intelligence/': {
      id: '/$org/apps/contract-intelligence/'
      path: '/'
      fullPath: '/$org/apps/contract-intelligence/'
      preLoaderRoute: typeof OrgAppsContractIntelligenceIndexRouteImport
      parentRoute: typeof OrgAppsContractIntelligenceRoute
    }
    '/$org/apps/contract-intelligence/documents': {
      id: '/$org/apps/contract-intelligence/documents'
      path: '/documents'
      fullPath: '/$org/apps/contract-intelligence/documents'
      preLoaderRoute: typeof OrgAppsContractIntelligenceDocumentsRouteImport
      parentRoute: typeof OrgAppsContractIntelligenceRoute
    }
    '/$org/apps/contract-intelligence/new': {
      id: '/$org/apps/contract-intelligence/new'
      path: '/new'
      fullPath: '/$org/apps/contract-intelligence/new'
      preLoaderRoute: typeof OrgAppsContractIntelligenceNewRouteImport
      parentRoute: typeof OrgAppsContractIntelligenceRoute
    }
    '/$org/apps/contract-intelligence/settings': {
      id: '/$org/apps/contract-intelligence/settings'
      path: '/settings'
      fullPath: '/$org/apps/contract-intelligence/settings'
      preLoaderRoute: typeof OrgAppsContractIntelligenceSettingsRouteImport
      parentRoute: typeof OrgAppsContractIntelligenceRoute
    }
    '/$org/apps/contract-intelligence/templates': {
      id: '/$org/apps/contract-intelligence/templates'
      path: '/templates'
      fullPath: '/$org/apps/contract-intelligence/templates'
      preLoaderRoute: typeof OrgAppsContractIntelligenceTemplatesRouteImport
      parentRoute: typeof OrgAppsContractIntelligenceRoute
    }
    '/$org/apps/custom/$serverId': {
      id: '/$org/apps/custom/$serverId'
      path: '/$org/apps/custom/$serverId'
      fullPath: '/$org/apps/custom/$serverId'
      preLoaderRoute: typeof OrgAppsCustomServerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/apps/imanage/': {
      id: '/$org/apps/imanage/'
      path: '/'
      fullPath: '/$org/apps/imanage/'
      preLoaderRoute: typeof OrgAppsImanageIndexRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/imanage/about': {
      id: '/$org/apps/imanage/about'
      path: '/about'
      fullPath: '/$org/apps/imanage/about'
      preLoaderRoute: typeof OrgAppsImanageAboutRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/imanage/favorites': {
      id: '/$org/apps/imanage/favorites'
      path: '/favorites'
      fullPath: '/$org/apps/imanage/favorites'
      preLoaderRoute: typeof OrgAppsImanageFavoritesRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/imanage/recent': {
      id: '/$org/apps/imanage/recent'
      path: '/recent'
      fullPath: '/$org/apps/imanage/recent'
      preLoaderRoute: typeof OrgAppsImanageRecentRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/imanage/saved': {
      id: '/$org/apps/imanage/saved'
      path: '/saved'
      fullPath: '/$org/apps/imanage/saved'
      preLoaderRoute: typeof OrgAppsImanageSavedRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/imanage/search': {
      id: '/$org/apps/imanage/search'
      path: '/search'
      fullPath: '/$org/apps/imanage/search'
      preLoaderRoute: typeof OrgAppsImanageSearchRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/imanage/settings': {
      id: '/$org/apps/imanage/settings'
      path: '/settings'
      fullPath: '/$org/apps/imanage/settings'
      preLoaderRoute: typeof OrgAppsImanageSettingsRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/probe/': {
      id: '/$org/apps/probe/'
      path: '/'
      fullPath: '/$org/apps/probe/'
      preLoaderRoute: typeof OrgAppsProbeIndexRouteImport
      parentRoute: typeof OrgAppsProbeRoute
    }
    '/$org/apps/probe/briefing': {
      id: '/$org/apps/probe/briefing'
      path: '/briefing'
      fullPath: '/$org/apps/probe/briefing'
      preLoaderRoute: typeof OrgAppsProbeBriefingRouteImport
      parentRoute: typeof OrgAppsProbeRoute
    }
    '/$org/apps/probe/practice': {
      id: '/$org/apps/probe/practice'
      path: '/practice'
      fullPath: '/$org/apps/probe/practice'
      preLoaderRoute: typeof OrgAppsProbePracticeRouteImport
      parentRoute: typeof OrgAppsProbeRoute
    }
    '/$org/compliance/findings/': {
      id: '/$org/compliance/findings/'
      path: '/findings'
      fullPath: '/$org/compliance/findings/'
      preLoaderRoute: typeof OrgComplianceFindingsIndexRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/findings/$findingId': {
      id: '/$org/compliance/findings/$findingId'
      path: '/findings/$findingId'
      fullPath: '/$org/compliance/findings/$findingId'
      preLoaderRoute: typeof OrgComplianceFindingsFindingIdRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/frameworks/': {
      id: '/$org/compliance/frameworks/'
      path: '/'
      fullPath: '/$org/compliance/frameworks/'
      preLoaderRoute: typeof OrgComplianceFrameworksIndexRouteImport
      parentRoute: typeof OrgComplianceFrameworksRoute
    }
    '/$org/compliance/frameworks/$frameworkId': {
      id: '/$org/compliance/frameworks/$frameworkId'
      path: '/$frameworkId'
      fullPath: '/$org/compliance/frameworks/$frameworkId'
      preLoaderRoute: typeof OrgComplianceFrameworksFrameworkIdRouteImport
      parentRoute: typeof OrgComplianceFrameworksRoute
    }
    '/$org/compliance/inspector_/$threadId': {
      id: '/$org/compliance/inspector_/$threadId'
      path: '/inspector/$threadId'
      fullPath: '/$org/compliance/inspector/$threadId'
      preLoaderRoute: typeof OrgComplianceInspectorThreadIdRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/integrations_/$integrationId': {
      id: '/$org/compliance/integrations_/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/$org/compliance/integrations/$integrationId'
      preLoaderRoute: typeof OrgComplianceIntegrationsIntegrationIdRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/policies/': {
      id: '/$org/compliance/policies/'
      path: '/'
      fullPath: '/$org/compliance/policies/'
      preLoaderRoute: typeof OrgCompliancePoliciesIndexRouteImport
      parentRoute: typeof OrgCompliancePoliciesRoute
    }
    '/$org/compliance/policies/$policyId': {
      id: '/$org/compliance/policies/$policyId'
      path: '/$policyId'
      fullPath: '/$org/compliance/policies/$policyId'
      preLoaderRoute: typeof OrgCompliancePoliciesPolicyIdRouteImport
      parentRoute: typeof OrgCompliancePoliciesRoute
    }
    '/$org/compliance/regimes_/$regimeId': {
      id: '/$org/compliance/regimes_/$regimeId'
      path: '/regimes/$regimeId'
      fullPath: '/$org/compliance/regimes/$regimeId'
      preLoaderRoute: typeof OrgComplianceRegimesRegimeIdRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/compliance/suggestions_/$recommendationId': {
      id: '/$org/compliance/suggestions_/$recommendationId'
      path: '/suggestions/$recommendationId'
      fullPath: '/$org/compliance/suggestions/$recommendationId'
      preLoaderRoute: typeof OrgComplianceSuggestionsRecommendationIdRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/connections_/mcp/$serverId': {
      id: '/$org/connections_/mcp/$serverId'
      path: '/$org/connections/mcp/$serverId'
      fullPath: '/$org/connections/mcp/$serverId'
      preLoaderRoute: typeof OrgConnectionsMcpServerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/$org/draft/$draftId': {
      id: '/_chat/$org/draft/$draftId'
      path: '/$org/draft/$draftId'
      fullPath: '/$org/draft/$draftId'
      preLoaderRoute: typeof ChatOrgDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/$org/apps/contract-intelligence/reviews/': {
      id: '/$org/apps/contract-intelligence/reviews/'
      path: '/reviews'
      fullPath: '/$org/apps/contract-intelligence/reviews/'
      preLoaderRoute: typeof OrgAppsContractIntelligenceReviewsIndexRouteImport
      parentRoute: typeof OrgAppsContractIntelligenceRoute
    }
    '/$org/apps/contract-intelligence/reviews/$reviewId': {
      id: '/$org/apps/contract-intelligence/reviews/$reviewId'
      path: '/reviews/$reviewId'
      fullPath: '/$org/apps/contract-intelligence/reviews/$reviewId'
      preLoaderRoute: typeof OrgAppsContractIntelligenceReviewsReviewIdRouteImport
      parentRoute: typeof OrgAppsContractIntelligenceRoute
    }
    '/$org/apps/imanage/w/$workspaceId': {
      id: '/$org/apps/imanage/w/$workspaceId'
      path: '/w/$workspaceId'
      fullPath: '/$org/apps/imanage/w/$workspaceId'
      preLoaderRoute: typeof OrgAppsImanageWWorkspaceIdRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/apps/probe/interviews/': {
      id: '/$org/apps/probe/interviews/'
      path: '/interviews'
      fullPath: '/$org/apps/probe/interviews/'
      preLoaderRoute: typeof OrgAppsProbeInterviewsIndexRouteImport
      parentRoute: typeof OrgAppsProbeRoute
    }
    '/$org/apps/probe/interviews/$sessionId': {
      id: '/$org/apps/probe/interviews/$sessionId'
      path: '/interviews/$sessionId'
      fullPath: '/$org/apps/probe/interviews/$sessionId'
      preLoaderRoute: typeof OrgAppsProbeInterviewsSessionIdRouteImport
      parentRoute: typeof OrgAppsProbeRoute
    }
    '/$org/compliance/integrations_/custom/$serverId': {
      id: '/$org/compliance/integrations_/custom/$serverId'
      path: '/integrations/custom/$serverId'
      fullPath: '/$org/compliance/integrations/custom/$serverId'
      preLoaderRoute: typeof OrgComplianceIntegrationsCustomServerIdRouteImport
      parentRoute: typeof OrgComplianceRoute
    }
    '/$org/apps/imanage/w/$workspaceId_/$folderId': {
      id: '/$org/apps/imanage/w/$workspaceId_/$folderId'
      path: '/w/$workspaceId/$folderId'
      fullPath: '/$org/apps/imanage/w/$workspaceId/$folderId'
      preLoaderRoute: typeof OrgAppsImanageWWorkspaceIdFolderIdRouteImport
      parentRoute: typeof OrgAppsImanageRoute
    }
    '/$org/compliance/policies/$policyId_/versions/$version': {
      id: '/$org/compliance/policies/$policyId_/versions/$version'
      path: '/$policyId/versions/$version'
      fullPath: '/$org/compliance/policies/$policyId/versions/$version'
      preLoaderRoute: typeof OrgCompliancePoliciesPolicyIdVersionsVersionRouteImport
      parentRoute: typeof OrgCompliancePoliciesRoute
    }
  }
}

interface ChatRouteChildren {
  ChatIndexRoute: typeof ChatIndexRoute
  ChatOrgThreadIdRoute: typeof ChatOrgThreadIdRoute
  ChatOrgChatRoute: typeof ChatOrgChatRoute
  ChatOrgIndexRoute: typeof ChatOrgIndexRoute
  ChatOrgDraftDraftIdRoute: typeof ChatOrgDraftDraftIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatIndexRoute: ChatIndexRoute,
  ChatOrgThreadIdRoute: ChatOrgThreadIdRoute,
  ChatOrgChatRoute: ChatOrgChatRoute,
  ChatOrgIndexRoute: ChatOrgIndexRoute,
  ChatOrgDraftDraftIdRoute: ChatOrgDraftDraftIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsBrandingRoute: typeof SettingsBrandingRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsMembersRoute: typeof SettingsMembersRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  SettingsUsageRoute: typeof SettingsUsageRoute
  SettingsYourContextRoute: typeof SettingsYourContextRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsBrandingRoute: SettingsBrandingRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsUsageRoute: SettingsUsageRoute,
  SettingsYourContextRoute: SettingsYourContextRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface OrgComplianceFrameworksRouteChildren {
  OrgComplianceFrameworksFrameworkIdRoute: typeof OrgComplianceFrameworksFrameworkIdRoute
  OrgComplianceFrameworksIndexRoute: typeof OrgComplianceFrameworksIndexRoute
}

const OrgComplianceFrameworksRouteChildren: OrgComplianceFrameworksRouteChildren =
  {
    OrgComplianceFrameworksFrameworkIdRoute:
      OrgComplianceFrameworksFrameworkIdRoute,
    OrgComplianceFrameworksIndexRoute: OrgComplianceFrameworksIndexRoute,
  }

const OrgComplianceFrameworksRouteWithChildren =
  OrgComplianceFrameworksRoute._addFileChildren(
    OrgComplianceFrameworksRouteChildren,
  )

interface OrgCompliancePoliciesRouteChildren {
  OrgCompliancePoliciesPolicyIdRoute: typeof OrgCompliancePoliciesPolicyIdRoute
  OrgCompliancePoliciesIndexRoute: typeof OrgCompliancePoliciesIndexRoute
  OrgCompliancePoliciesPolicyIdVersionsVersionRoute: typeof OrgCompliancePoliciesPolicyIdVersionsVersionRoute
}

const OrgCompliancePoliciesRouteChildren: OrgCompliancePoliciesRouteChildren = {
  OrgCompliancePoliciesPolicyIdRoute: OrgCompliancePoliciesPolicyIdRoute,
  OrgCompliancePoliciesIndexRoute: OrgCompliancePoliciesIndexRoute,
  OrgCompliancePoliciesPolicyIdVersionsVersionRoute:
    OrgCompliancePoliciesPolicyIdVersionsVersionRoute,
}

const OrgCompliancePoliciesRouteWithChildren =
  OrgCompliancePoliciesRoute._addFileChildren(
    OrgCompliancePoliciesRouteChildren,
  )

interface OrgComplianceRouteChildren {
  OrgComplianceFrameworksRoute: typeof OrgComplianceFrameworksRouteWithChildren
  OrgComplianceInspectorRoute: typeof OrgComplianceInspectorRoute
  OrgComplianceIntegrationsRoute: typeof OrgComplianceIntegrationsRoute
  OrgComplianceKnowledgeRoute: typeof OrgComplianceKnowledgeRoute
  OrgCompliancePoliciesRoute: typeof OrgCompliancePoliciesRouteWithChildren
  OrgComplianceProbeRoute: typeof OrgComplianceProbeRoute
  OrgComplianceProceduresRoute: typeof OrgComplianceProceduresRoute
  OrgComplianceRegimesRoute: typeof OrgComplianceRegimesRoute
  OrgComplianceRegulatoryRoute: typeof OrgComplianceRegulatoryRoute
  OrgComplianceSuggestionsRoute: typeof OrgComplianceSuggestionsRoute
  OrgComplianceTemplatesRoute: typeof OrgComplianceTemplatesRoute
  OrgComplianceIndexRoute: typeof OrgComplianceIndexRoute
  OrgComplianceFindingsFindingIdRoute: typeof OrgComplianceFindingsFindingIdRoute
  OrgComplianceInspectorThreadIdRoute: typeof OrgComplianceInspectorThreadIdRoute
  OrgComplianceIntegrationsIntegrationIdRoute: typeof OrgComplianceIntegrationsIntegrationIdRoute
  OrgComplianceRegimesRegimeIdRoute: typeof OrgComplianceRegimesRegimeIdRoute
  OrgComplianceSuggestionsRecommendationIdRoute: typeof OrgComplianceSuggestionsRecommendationIdRoute
  OrgComplianceFindingsIndexRoute: typeof OrgComplianceFindingsIndexRoute
  OrgComplianceIntegrationsCustomServerIdRoute: typeof OrgComplianceIntegrationsCustomServerIdRoute
}

const OrgComplianceRouteChildren: OrgComplianceRouteChildren = {
  OrgComplianceFrameworksRoute: OrgComplianceFrameworksRouteWithChildren,
  OrgComplianceInspectorRoute: OrgComplianceInspectorRoute,
  OrgComplianceIntegrationsRoute: OrgComplianceIntegrationsRoute,
  OrgComplianceKnowledgeRoute: OrgComplianceKnowledgeRoute,
  OrgCompliancePoliciesRoute: OrgCompliancePoliciesRouteWithChildren,
  OrgComplianceProbeRoute: OrgComplianceProbeRoute,
  OrgComplianceProceduresRoute: OrgComplianceProceduresRoute,
  OrgComplianceRegimesRoute: OrgComplianceRegimesRoute,
  OrgComplianceRegulatoryRoute: OrgComplianceRegulatoryRoute,
  OrgComplianceSuggestionsRoute: OrgComplianceSuggestionsRoute,
  OrgComplianceTemplatesRoute: OrgComplianceTemplatesRoute,
  OrgComplianceIndexRoute: OrgComplianceIndexRoute,
  OrgComplianceFindingsFindingIdRoute: OrgComplianceFindingsFindingIdRoute,
  OrgComplianceInspectorThreadIdRoute: OrgComplianceInspectorThreadIdRoute,
  OrgComplianceIntegrationsIntegrationIdRoute:
    OrgComplianceIntegrationsIntegrationIdRoute,
  OrgComplianceRegimesRegimeIdRoute: OrgComplianceRegimesRegimeIdRoute,
  OrgComplianceSuggestionsRecommendationIdRoute:
    OrgComplianceSuggestionsRecommendationIdRoute,
  OrgComplianceFindingsIndexRoute: OrgComplianceFindingsIndexRoute,
  OrgComplianceIntegrationsCustomServerIdRoute:
    OrgComplianceIntegrationsCustomServerIdRoute,
}

const OrgComplianceRouteWithChildren = OrgComplianceRoute._addFileChildren(
  OrgComplianceRouteChildren,
)

interface OrgSettingsRouteChildren {
  OrgSettingsSectionRoute: typeof OrgSettingsSectionRoute
}

const OrgSettingsRouteChildren: OrgSettingsRouteChildren = {
  OrgSettingsSectionRoute: OrgSettingsSectionRoute,
}

const OrgSettingsRouteWithChildren = OrgSettingsRoute._addFileChildren(
  OrgSettingsRouteChildren,
)

interface OrgAppsContractIntelligenceRouteChildren {
  OrgAppsContractIntelligenceDocumentsRoute: typeof OrgAppsContractIntelligenceDocumentsRoute
  OrgAppsContractIntelligenceNewRoute: typeof OrgAppsContractIntelligenceNewRoute
  OrgAppsContractIntelligenceSettingsRoute: typeof OrgAppsContractIntelligenceSettingsRoute
  OrgAppsContractIntelligenceTemplatesRoute: typeof OrgAppsContractIntelligenceTemplatesRoute
  OrgAppsContractIntelligenceIndexRoute: typeof OrgAppsContractIntelligenceIndexRoute
  OrgAppsContractIntelligenceReviewsReviewIdRoute: typeof OrgAppsContractIntelligenceReviewsReviewIdRoute
  OrgAppsContractIntelligenceReviewsIndexRoute: typeof OrgAppsContractIntelligenceReviewsIndexRoute
}

const OrgAppsContractIntelligenceRouteChildren: OrgAppsContractIntelligenceRouteChildren =
  {
    OrgAppsContractIntelligenceDocumentsRoute:
      OrgAppsContractIntelligenceDocumentsRoute,
    OrgAppsContractIntelligenceNewRoute: OrgAppsContractIntelligenceNewRoute,
    OrgAppsContractIntelligenceSettingsRoute:
      OrgAppsContractIntelligenceSettingsRoute,
    OrgAppsContractIntelligenceTemplatesRoute:
      OrgAppsContractIntelligenceTemplatesRoute,
    OrgAppsContractIntelligenceIndexRoute:
      OrgAppsContractIntelligenceIndexRoute,
    OrgAppsContractIntelligenceReviewsReviewIdRoute:
      OrgAppsContractIntelligenceReviewsReviewIdRoute,
    OrgAppsContractIntelligenceReviewsIndexRoute:
      OrgAppsContractIntelligenceReviewsIndexRoute,
  }

const OrgAppsContractIntelligenceRouteWithChildren =
  OrgAppsContractIntelligenceRoute._addFileChildren(
    OrgAppsContractIntelligenceRouteChildren,
  )

interface OrgAppsImanageRouteChildren {
  OrgAppsImanageAboutRoute: typeof OrgAppsImanageAboutRoute
  OrgAppsImanageFavoritesRoute: typeof OrgAppsImanageFavoritesRoute
  OrgAppsImanageRecentRoute: typeof OrgAppsImanageRecentRoute
  OrgAppsImanageSavedRoute: typeof OrgAppsImanageSavedRoute
  OrgAppsImanageSearchRoute: typeof OrgAppsImanageSearchRoute
  OrgAppsImanageSettingsRoute: typeof OrgAppsImanageSettingsRoute
  OrgAppsImanageIndexRoute: typeof OrgAppsImanageIndexRoute
  OrgAppsImanageWWorkspaceIdRoute: typeof OrgAppsImanageWWorkspaceIdRoute
  OrgAppsImanageWWorkspaceIdFolderIdRoute: typeof OrgAppsImanageWWorkspaceIdFolderIdRoute
}

const OrgAppsImanageRouteChildren: OrgAppsImanageRouteChildren = {
  OrgAppsImanageAboutRoute: OrgAppsImanageAboutRoute,
  OrgAppsImanageFavoritesRoute: OrgAppsImanageFavoritesRoute,
  OrgAppsImanageRecentRoute: OrgAppsImanageRecentRoute,
  OrgAppsImanageSavedRoute: OrgAppsImanageSavedRoute,
  OrgAppsImanageSearchRoute: OrgAppsImanageSearchRoute,
  OrgAppsImanageSettingsRoute: OrgAppsImanageSettingsRoute,
  OrgAppsImanageIndexRoute: OrgAppsImanageIndexRoute,
  OrgAppsImanageWWorkspaceIdRoute: OrgAppsImanageWWorkspaceIdRoute,
  OrgAppsImanageWWorkspaceIdFolderIdRoute:
    OrgAppsImanageWWorkspaceIdFolderIdRoute,
}

const OrgAppsImanageRouteWithChildren = OrgAppsImanageRoute._addFileChildren(
  OrgAppsImanageRouteChildren,
)

interface OrgAppsProbeRouteChildren {
  OrgAppsProbeBriefingRoute: typeof OrgAppsProbeBriefingRoute
  OrgAppsProbePracticeRoute: typeof OrgAppsProbePracticeRoute
  OrgAppsProbeIndexRoute: typeof OrgAppsProbeIndexRoute
  OrgAppsProbeInterviewsSessionIdRoute: typeof OrgAppsProbeInterviewsSessionIdRoute
  OrgAppsProbeInterviewsIndexRoute: typeof OrgAppsProbeInterviewsIndexRoute
}

const OrgAppsProbeRouteChildren: OrgAppsProbeRouteChildren = {
  OrgAppsProbeBriefingRoute: OrgAppsProbeBriefingRoute,
  OrgAppsProbePracticeRoute: OrgAppsProbePracticeRoute,
  OrgAppsProbeIndexRoute: OrgAppsProbeIndexRoute,
  OrgAppsProbeInterviewsSessionIdRoute: OrgAppsProbeInterviewsSessionIdRoute,
  OrgAppsProbeInterviewsIndexRoute: OrgAppsProbeInterviewsIndexRoute,
}

const OrgAppsProbeRouteWithChildren = OrgAppsProbeRoute._addFileChildren(
  OrgAppsProbeRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  AutomationsRoute: AutomationsRoute,
  ComplianceRoute: ComplianceRoute,
  ConnectRoute: ConnectRoute,
  ConnectionsRoute: ConnectionsRoute,
  InboxRoute: InboxRoute,
  LibraryRoute: LibraryRoute,
  PairRoute: PairRoute,
  RegulationRoute: RegulationRoute,
  SettingsRoute: SettingsRouteWithChildren,
  UsageRoute: UsageRoute,
  OrgAgentsRoute: OrgAgentsRoute,
  OrgAutomationsRoute: OrgAutomationsRoute,
  OrgCommandCenterRoute: OrgCommandCenterRoute,
  OrgComplianceRoute: OrgComplianceRouteWithChildren,
  OrgConnectionsRoute: OrgConnectionsRoute,
  OrgInboxRoute: OrgInboxRoute,
  OrgSettingsRoute: OrgSettingsRouteWithChildren,
  OrgUsageRoute: OrgUsageRoute,
  ConnectCallbackRoute: ConnectCallbackRoute,
  ConnectionsPluginIdRoute: ConnectionsPluginIdRoute,
  OrgAppsAppIdRoute: OrgAppsAppIdRoute,
  OrgAppsContractIntelligenceRoute:
    OrgAppsContractIntelligenceRouteWithChildren,
  OrgAppsImanageRoute: OrgAppsImanageRouteWithChildren,
  OrgAppsProbeRoute: OrgAppsProbeRouteWithChildren,
  OrgConnectionsPluginIdRoute: OrgConnectionsPluginIdRoute,
  OrgRegulationSplatRoute: OrgRegulationSplatRoute,
  OrgSkillsSlugRoute: OrgSkillsSlugRoute,
  OrgSpacesSpaceIdRoute: OrgSpacesSpaceIdRoute,
  OrgWorkflowsWorkflowIdRoute: OrgWorkflowsWorkflowIdRoute,
  OrgAppsIndexRoute: OrgAppsIndexRoute,
  OrgRegulationIndexRoute: OrgRegulationIndexRoute,
  OrgSkillsIndexRoute: OrgSkillsIndexRoute,
  OrgSpacesIndexRoute: OrgSpacesIndexRoute,
  OrgWorkflowsIndexRoute: OrgWorkflowsIndexRoute,
  OrgAppsCustomServerIdRoute: OrgAppsCustomServerIdRoute,
  OrgConnectionsMcpServerIdRoute: OrgConnectionsMcpServerIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
